// IMPORTS FOR ALL MEDIA FOR OBJECT allContentFull
//FOR WEEK 1
import slide11 from "./assets/newImages/ram_w1_v1_th.webp";
import slide12 from "./assets/newImages/ram_w1_v2_th.webp";
import poster11 from "./assets/newPosters/DTE_Retail Heroes_Week1_Love Story_Thumbnail.webp";
import poster12 from "./assets/newPosters/DTE_Retail Heroes_Week1_Lost Tourists_Thumbnail.webp";
import meme11 from "./assets/newMemes/DTE_Retail Heroes_Week1_Love Story_MEME.gif";
import meme12 from "./assets/newMemes/DTE_Retail Heroes_Week1_Lost Tourists_MEME.gif";
import video11 from "./assets/videos/PM_RAM_Story01.mp4";
import video12 from "./assets/videos/PM_RAM_Story02.mp4";
import sticker1 from "./assets/allStickersNew/stickerGottaGo.svg";
import stickersCoverWeek1 from "./assets/newImages/RAM_W1_Stickers_Cover.svg";
//FOR WEEK 2
import slide21 from "./assets/newImages/ram_w2_v1_th.webp";
import slide22 from "./assets/newImages/ram_w2_v2_th.webp";
import poster21 from "./assets/newPosters/DTE_Retail Heroes_Week2_ReConnect_Thumbnail.webp";
import poster22 from "./assets/newPosters/DTE_Retail Heroes_Week2_ReCharge_Thumbnail.webp";
import meme21 from "./assets/newMemes/DTE_Retail Heroes_Week2_ReConnect_MEME.gif";
import meme22 from "./assets/newMemes/DTE_Retail Heroes_Week2_ReCharge_MEME.gif";
import video21 from "./assets/videos/PM_RAM_Story03.mp4";
import video22 from "./assets/videos/PM_RAM_Story04.mp4";
import sticker2 from "./assets/allStickersNew/stickerMissYou.svg";
import stickersCoverWeek2 from "./assets/newImages/RAM_W2_Stickers_Cover.svg";
//FOR WEEK 3
import slide31 from "./assets/newImages/ram_w3_v1_th.webp";
import slide32 from "./assets/newImages/ram_w3_v2_th.webp";
import poster31 from "./assets/newPosters/DTE_Retail Heroes_Week3_Warm Up_Thumbnail.webp";
import poster32 from "./assets/newPosters/DTE_Retail Heroes_Week3_After Hours_Thumbnail.webp";
import meme31 from "./assets/newMemes/DTE_Retail Heroes_Week3_Warm Up_MEME.gif";
import meme32 from "./assets/newMemes/DTE_Retail Heroes_Week3_After Hours_MEME.gif";
import video31 from "./assets/videos/PM_RAM_Story05.mp4";
import video32 from "./assets/videos/PM_RAM_Story06.mp4";
import sticker3 from "./assets/allStickersNew/stickerLowEnergy.svg";
import stickersCoverWeek3 from "./assets/newImages/RAM_W3_Stickers_Cover.svg";
//FOR WEEK 4
import slide41 from "./assets/newImages/ram_w4_th.webp";
import video41 from "./assets/videos/PM_RAM_Emotional Finale.mp4";
import sticker4 from "./assets/allStickersNew/stickerStayHome.svg";
import stickersCoverWeek4 from "./assets/newImages/RAM_W4_Stickers_Cover.svg";
//FOR GIFT
import allStickersGiftWeek from "./assets/allStickersNew/stickerAll.svg";
import announcement from "./assets/newImages/Announcement.svg";
import newGoodies from "./assets/newImages/NewGoodies.svg";

const allContent = {
  //timestamps for change time for weeks
  timestamps: [1684162295000, 1684162295000, 1684162295000, 1684162295000],
  // main part
  main: {
    title1: "Dear Partner",
    title2: "We wanted to say Thank You!",
    text1:
      "We know what it means to be a retailer, the long hours, the late nights, the ups and the downs.",
    text2:
      "Enjoy six heart-warming films inspired by your lives! Discover new episodes and collect stickers every week.",
    button: "Discover now",
    watch: "Watch videos to unlock fun GIF",
    watch2: "Watch video to unlock stickers",
    announcement: announcement,
    newGoodies: newGoodies,
  },
  week1: {
    episode: "episode 1",
    title: "LOST \n & FOUND",
    description:
      "See how your simple gestures can take people places and bring them together.",
    thumbnailImg1: slide12,
    thumbnailImg2: slide11,
    thumbnailTitle1: "Lost tourists",
    thumbnailTitle2: "Love Story",
    posterMeme1: poster12,
    posterMeme2: poster11,
    gif1: meme12,
    gif2: meme11,
    video1: video12,
    video2: video11,
    sticker: sticker1,
    multipleSticker: stickersCoverWeek1,
  },
  week2: {
    episode: "episode 2",
    title: "RECHARGE \n & RECONNECT",
    description:
      "Watch how the everyday problems are solved by the things you do.",
    thumbnailImg1: slide21,
    thumbnailImg2: slide22,
    thumbnailTitle1: "ReConnect",
    thumbnailTitle2: "ReCharge",
    posterMeme1: poster21,
    posterMeme2: poster22,
    gif1: meme21,
    gif2: meme22,
    video1: video21,
    video2: video22,
    sticker: sticker2,
    multipleSticker: stickersCoverWeek2,
  },
  week3: {
    episode: "episode 3",
    title: "AFTER HOURS \n & SHELTER",
    description:
      "Find out how your dedication and kindness helps those around you.",
    thumbnailImg1: slide31,
    thumbnailImg2: slide32,
    thumbnailTitle1: "Warm up",
    thumbnailTitle2: "After Hours",
    posterMeme1: poster31,
    posterMeme2: poster32,
    gif1: meme31,
    gif2: meme32,
    video1: video31,
    video2: video32,
    sticker: sticker3,
    multipleSticker: stickersCoverWeek3,
  },
  week4: {
    episode: "episode 4",
    title: "THANK YOU \n FOR ALL",
    description:
      "Watch how everything you do is appreciated by people all around the world.",
    thumbnailImg1: slide41,
    thumbnailTitle1: "Thank You",
    video1: video41,
    sticker: sticker4,
    multipleSticker: stickersCoverWeek4,
  },
  // gift part
  gift: {
    title1: "Dear Partner",
    title2: "Thanks for \n being here !",
    description1:
      "Your hard work and dedication\n make all the difference and\n we can't thank you enough. You're a true retail hero and we're lucky to have you on our team!",
    description2:
      "You are just a click away from downloading your sticker collection.",
    button: "Download Collection",
    stickers: allStickersGiftWeek,
    weekGift: "Gift",
    getGift: "get a gift",
  },
  collectWindow: {
    titles: {
      title1: "You’ve collected \n Week 1 Set",
      title2: "You’ve collected \n Week 2 Set",
      title3: "You’ve collected \n Week 3 Set",
      title4: "You’ve collected \n Week 4 Set",
    },
    titlesMobile: {
      firstPart: "You’ve collected \n Week",
      secondPart: "Set",
    },
    description:
      "Continue watching \n more videos and collect more \n stickers in upcoming weeks.",
    button: "Continue",
  },
  infoWindow: {
    watch: "Watch \n Videos",
    claim: "Claim \n All Stickers",
    download: "Download Sticker Set",
  },
  week: "Week",
  watchVideo: "Watch two videos \n to unlock stickers",
  collectSticker: "collect \n sticker",
  clickToOpen: "Click \n to open",
  mobileComeback1: "slika",
  mobileComeback2: "slika",
  openNow: "Open now",
  openAgain: "Open Again",
  collectableSticker: "Collectable \n stickers",
  buttonCollectSticker: {
    button1: "Collect Stickers",
    button2: "Collected Stickers",
  },
};

export default allContent;
